import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { LoadingService } from '../../core/services/helpers/loading.service';
import { AppTabBarComponent } from './tab-bar/tab-bar.component';

@Component({
  selector: 'app-tabs',
  template: ` 
    <div *ngIf="loader | async" class="global-spinner-overlay">
      <nz-spin nzSize="large" nzTip="Loading..." style="width:100%"></nz-spin>
    </div>
      <app-tab-bar></app-tab-bar> 
    `,
  imports: [
    CommonModule,
    NzGridModule,
    NzSpinModule,
    RouterModule,
    AppTabBarComponent,
    CommonModule,
    NzGridModule,
    RouterModule,
  ],
})
export class AppTabsComponent {
  readonly loader = inject(LoadingService).get();
}
